import React ,{Component} from 'react';
import { NavLink,Navigate  } from 'react-router-dom';
import axios from 'axios'; 
import Table from '@mui/material/Table';
import Serverurl from './Apiurl';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import TableRow from '@mui/material/TableRow'; 
import { makeStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';  
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody'; 
import TableCell from '@mui/material/TableCell';  
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';  
import TablePagination from '@mui/material/TablePagination'; 
import TextField from '@mui/material/TextField';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort(array, cmp) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
  return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

const headCells = [

 
  { id: 'st_name', numeric: false, label: 'Name' },
  { id: 'st_emailid', numeric: false, label: 'Email Id' },
  { id: 'st_phoneno', numeric: false, label: 'Phone No.' },  
   { id: 'st_branch', numeric: false,  label: 'Branch' },
    { id: 'st_role', numeric: false,  label: 'Role' },
  { id: '', numeric: false,  label: '' },

]
function EnhancedTableHead(props) {
  const { classes,  order, orderBy,  rowCount, onRequestSort } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={useStyles.visuallyHidden}>
                  {order === 'desc' ? ' ' : ' '}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
 
  onRequestSort: PropTypes.func.isRequired,
 
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
const useToolbarStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  
  
  title: {
    flex: '1 1 100%',
  },
}));

const EnhancedTableToolbar = props => {
  const classes = useToolbarStyles();
  const { numSelected } = props;

  
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};



const useStyles = makeStyles({  
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 
 icon: {
   verticalalign:'middle',
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },  
});





export default class  Adminstaff extends Component {
	
	
	constructor(props) {
    super();
	
	 this.state = {st_isdisplay:'',
logredirect:false,pagename:'',StaffData:[] ,id:'',editredirect: false,page: 0 ,prevpage:0,totaldata:0,rowsPerPage:10,rowsPaging:[],
	 
	  search:'',order:'desc' ,orderBy:'',name:'',searchnamearray:[],isactive:'',searchactive:'',role:'',branchdata:[],branch:'',branchlabel:'Select Branch',
		       
      }
	 };
    
   

    
   
  


myChangeHandler = (event) => {
  let nam = event.target.name;
  let val = event.target.value;
  
   

  this.setState({[nam]: val});

}







 getParameterByName(name, url) {
    if (!url) url = window.location.href;
    url = url.toLowerCase(); 
    name = name.replace(/[\[\]]/g, "\\$&").toLowerCase();
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}


 handleClickSearch=()=>{
	
localStorage.setItem("name", this.state.search); 

	localStorage.setItem("page",this.state.rowsPerPage);
  //this.apicall(this.state.page,this.state.rowsPerPage); 

this.setState({  
      page: 0,
      rowsPerPage:50,
	  prevpage:0,StaffData:[],Data:[],
    },()=>{this.apicall(this.state.page,this.state.rowsPerPage); });
	
  
	
} 

componentWillMount() {
		document.title = "AthaYog Living - Staff Management";
		if(localStorage.getItem("AYLuserid")==null)
		  {

		   this.setState({
            logredirect: true,
			pagename:'/Default'
          })
		  }
		  
	this.branchbind();		  
	
 this.apicall(this.state.page,this.state.rowsPerPage);   
	}
	

	
	
	
	apicall(page,rowsPerPage){
 
  
  axios.get(Serverurl+'ajaxstaff.php?action=getall&st_name='+this.state.name+'&st_bm_id='+this.state.branch+'&st_role='+this.state.role+'&StartIndex='+page+'&PageSize='+rowsPerPage)
  .then(resp => {  
		
    if(resp.data.length>0){
		
			this.setState({  
			  StaffData: resp.data,  
			   totaldata:parseInt(resp.data[0].count),
			});
			
			
	  

	 
     }
	 else{
		   this.setState({StaffData:[],totaldata:0});
	 }
   
    });

}

branchbind(){

    axios.get(Serverurl+'ajaxbranch.php?action=getall')
	
    
      .then((resp) => {    
     
let strbrid=this.state.branch;

								if(resp.data.length===1 && strbrid=='')
								{
									strbrid=resp.data[0]["bm_id"];
								}
	  
	
	  let BranchApi = resp.data.map(row => {
                      
          return {value: row.bm_id, display:row.bm_name}
        });
		
		 this.setState({branch:strbrid,
          branchdata: [{value: '', display:'Select Branch'}].concat(BranchApi)
        },()=>{console.log(this.state.branchdata)});
      }).then(data => {
		 
        
      
		
       
      }) 
    
     


}  
  
handleRequestSort = (event, property) => {
  const isAsc = this.state.orderBy === property && this.state.order === 'asc';
  

  this.setState({   orderBy: property,
    order:isAsc  ? 'desc' : 'asc'
   
  });
};

handleChangePage = (event, newPage) => {  

    let pageval = localStorage.getItem("page");
    this.setState({  
      page: newPage,
      rowsPerPage:this.state.rowsPerPage
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage);  });
   
 
    
  };   
  
  
   handleChangeRowsPerPage = event => {  
  
    let pageval = event.target.value;
  

   
    this.setState({  
      page: 0,
      rowsPerPage:parseInt(pageval),
	  prevpage:-1
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage); }); 
	
	
  };
 
 deleteStaff(stid){  
  
		let r = window.confirm("Do you really want to Delete?");
		 if(r == true){ //sign Out logic
				 var formData = new FormData(); 
					 formData.append('action','delete')					 
					 formData.append('st_id',stid)
					 formData.append('userid',localStorage.getItem("AYLuserid"))
					  axios.post(Serverurl+"ajaxstaff.php", formData, {
						}).then(res => {
					
							 this.setState({  
      prevpage: -1,
    
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage); });
				  
					
					
							});
		 }
 }
	  
editstaff(id) {
        localStorage.setItem("stid", id);
       
		 this.setState({ editredirect: true})
		
 }
 
 

handleDisplay(stid,val){
	let strmsg="Show";
	 if(val===0)
	 {
		strmsg="Hide"; 
	 }
	 let r = window.confirm("Do you really want to "+strmsg+" ?");
		 if(r == true){ //sign Out logic
				 var formData = new FormData(); 
					 formData.append('action','isdisplay')
					 formData.append('st_id',stid)
					 formData.append('st_isdisplay',val)
					 formData.append('userid',localStorage.getItem("AYLuserid"))
					 
					  axios.post(Serverurl+"ajaxstaff.php", formData, {
						}).then(res => {
					
							this.apicall(this.state.page,this.state.rowsPerPage);
   
				  
					
					
							});
		 }
 
 } 

 
 
 
 
 
 

 
render() {
		if (this.state.logredirect === true) {
      return <Navigate to={this.state.pagename} />
    } 
  return (
   <React.Fragment>
   

<div className="boxheading">
				
<h2> Manage Yoga Trainer</h2>

</div>
<div className="addandbacbtn"> <NavLink  to="/Addstaff" >New </NavLink></div>

<div className="clear"></div>
   <div className="searchmaster"> 
   





<ul>
	
<li>
 
<p>Name/Email/Phone No.</p>
		<p><TextField
            variant="outlined"
            margin="normal"
            fullWidth value={this.state.name} className="txtbox"
            id="name"
           inputProps={{tabIndex: "1",maxLength:150}}
            name="name" onChange={this.myChangeHandler}
         
           
          /></p>
		
		</li>
		<li>  
		  
		 <p>Role</p>
		<p><FormControl  className="stadrp">
				
		 <Select
         native
		 variant="outlined"
          margin="normal"
          onChange={this.myChangeHandler} inputProps={{tabIndex: "2"}}
          id="role" className="txtbox"
		   value={this.state.role}
		  name="role"
		
        >
	<option value={0}>Select Role</option>
	<option value={1}>Admin</option>
	<option value={2}>Manager</option>	
	<option value={3}>Yoga Trainer</option>	
        </Select>

		</FormControl>
		</p>
 
 </li>
	{localStorage.getItem("AYLrole")==="1" && (	
<li><p>Branch</p><p><FormControl  className="stadrp">
         
        <Select
         native  fullWidth		 
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.branchlabel, value: this.state.branch}}
          onChange={this.myChangeHandler}
          id="branch" className="txtbox"
		   value={this.state.branch} inputProps={{tabIndex: "3"}}
		  name="branch"
		
		
        >
		{this.state.branchdata.map(br => (
            <option  
            
              value={br.value}
            >
              {br.display}
            </option  >
          ))}
		
        </Select></FormControl>
		
	</p></li>)}
 
 <li><p>
		<Button variant="contained" onClick={this.handleClickSearch} className="frmSecondarybtn" endIcon={<SearchIcon />}>
        Search
      </Button></p></li>
 
 
 </ul>
</div>
<Paper className={useStyles.root}>
  <TableContainer className={useStyles.container}>  
                <Table stickyHeader aria-label="sticky table">  

					  
					   <EnhancedTableHead
             
              
              order={this.state.order}
              orderBy={this.state.orderBy}
              
              onRequestSort={this.handleRequestSort}
              rowCount={this.state.StaffData.length}
            />
			
			
			
                      <TableBody>

                     {stableSort(this.state.StaffData, getSorting(this.state.order, this.state.orderBy)).map((item,index) =>{
 if(this.state.totaldata>0)					
	 {   return ( <React.Fragment>
 <TableRow key={index} >

	
	

  <TableCell>{item.st_name}</TableCell>
<TableCell>{item.st_emailid}</TableCell>
<TableCell>{item.st_phoneno}</TableCell>
	<TableCell>{item.bm_name}</TableCell>
	<TableCell>{item.role}</TableCell>
	
	
	
<TableCell align="left">
<a href={'/Addstaff?stid='+item.st_id}>
<Button variant="contained" className="frmSecondarybtn" endIcon={<EditIcon />}>
Edit
</Button></a>  
	{item.st_role !=="1" &&( <React.Fragment>	
	
 <Button variant="contained" className="frmthirdbtn" onClick={()=>{this.deleteStaff(item.st_id)}} endIcon={<DeleteIcon />}>
Delete
</Button>&nbsp;

	

 {item.st_isdisplay ==="0" &&(
<Button variant="contained" className="frmSecondarybtn" onClick={()=>{this.handleDisplay(item.st_id,1)}} endIcon={<	RemoveRedEyeIcon/>} >
Show
</Button>

 )}
 &nbsp;
 {item.st_isdisplay ==="1" &&(

	<Button variant="contained" className="frmSecondarybtn" onClick={()=>{this.handleDisplay(item.st_id,0)}}    endIcon={<VisibilityOffIcon />}>
 Hide
</Button>
 
  )}

	</React.Fragment>
)}
	
 </TableCell>

 </TableRow>


				</React.Fragment>	
				);
	 }
						 else{
					 return ( <React.Fragment>
				<TableRow  >
<TableCell colspan="5">
<h3>No Records</h3>
</TableCell>
				</TableRow>
				</React.Fragment>	
				);	
				}
					})}
                      </TableBody>


</Table>
  </TableContainer> 
 <TablePagination  
          rowsPerPageOptions={[50,100,200,300,400]}
        component="div"  
        count={this.state.totaldata}  
        rowsPerPage={this.state.rowsPerPage}  
        page={this.state.page}  
        onPageChange={this.handleChangePage}  
        onRowsPerPageChange={this.handleChangeRowsPerPage}    
      />    
  </Paper>
   
 

   
 </React.Fragment>

		  );
  }	
   
   
  
  
  
  
	
}